import { useMemo } from "react";

interface BaliHolidayNoteProps {
  isDe: boolean;
  blockedDates: Set<string>;
  className?: string;
}

/**
 * Erklärt, warum einzelne Tage im Tour-Kalender ausgegraut sind,
 * und nennt die nächsten nicht buchbaren Tage.
 */
export default function BaliHolidayNote({ isDe, blockedDates, className }: BaliHolidayNoteProps) {
  const next = useMemo(() => {
    const today = new Date().toISOString().split("T")[0];
    return Array.from(blockedDates)
      .filter((d) => d >= today)
      .sort()
      .slice(0, 3);
  }, [blockedDates]);

  const format = (iso: string) => {
    const parts = iso.split("-").map(Number);
    if (parts.length < 3) return iso;
    const d = new Date(parts[0], parts[1] - 1, parts[2]);
    return d.toLocaleDateString(isDe ? "de-DE" : "en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div
      className={`mt-2.5 flex items-start gap-2.5 rounded-md border border-accent-200 bg-accent-100/60 px-3.5 py-3 ${className ?? ""}`}
    >
      <span className="w-5 h-5 shrink-0 flex items-center justify-center text-accent-700">
        <i className="ri-information-line"></i>
      </span>
      <div className="text-xs leading-relaxed text-foreground-700">
        <span className="font-semibold text-foreground-900">
          {isDe ? "Bali Holiday – bitte beachten: " : "Bali Holiday – please note: "}
        </span>
        {isDe
          ? "An balinesischen Feiertagen wie Nyepi (Tag der Stille), Galungan und Kuningan finden keine Touren statt. Diese Tage sind im Kalender ausgegraut und nicht wählbar."
          : "No tours take place on Balinese holidays such as Nyepi (Day of Silence), Galungan and Kuningan. These days are greyed out in the calendar and cannot be selected."}
        {next.length > 0 && (
          <span className="block mt-1 text-foreground-600">
            <span className="font-medium">
              {isDe ? "Nächste nicht buchbare Tage: " : "Next unavailable days: "}
            </span>
            {next.map(format).join(" · ")}
          </span>
        )}
      </div>
    </div>
  );
}